import React from 'react';
import { motion } from 'framer-motion';
import { Unlock, Zap, Eye, Code, Power } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: <Code size={24} data-id="element-9" />,
    text: 'Entender cómo funciona la realidad y sus reglas ocultas'
  }, {
    icon: <Unlock size={24} data-id="element-10" />,
    text: 'Romper patrones mentales limitantes instalados en ti'
  }, {
    icon: <Zap size={24} data-id="element-11" />,
    text: 'Despertar tu conciencia a un nuevo nivel de percepción'
  }, {
    icon: <Power size={24} data-id="element-12" />,
    text: 'Recuperar tu poder personal y salir del modo víctima'
  }, {
    icon: <Eye size={24} data-id="element-13" />,
    text: 'Ver más allá de la ilusión y diseñar tu propia vida'
  }];
  return <section className="py-24 bg-matrix-dark relative px-4 border-y border-matrix-green/10" data-id="element-14">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-15">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="font-cinzel text-3xl md:text-5xl text-center text-matrix-cream mb-16" data-id="element-16">
          Al leer este libro, aprenderás a:
        </motion.h2>

        <div className="space-y-6" data-id="element-17">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-center gap-6 bg-matrix-black/50 p-6 rounded-lg border border-matrix-green/10 hover:border-matrix-green/40 transition-colors" data-id="element-18">
              <div className="text-matrix-green bg-matrix-green/10 p-3 rounded-md" data-id="element-19">
                {benefit.icon}
              </div>
              <p className="text-matrix-white text-lg md:text-xl font-light" data-id="element-20">
                {benefit.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}